var render = function () {
  var _vm$book, _vm$book2, _vm$book3, _vm$book4, _vm$book5, _vm$book6, _vm$book7, _vm$book8, _vm$book9, _vm$book10, _vm$book11, _vm$book12, _vm$book13, _vm$book13$photo, _vm$book14, _vm$book14$photo, _vm$book15, _vm$book16, _vm$book16$photo, _vm$book17, _vm$book17$photo, _vm$book18, _vm$book19, _vm$book20;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container sub_wrap",
    attrs: {
      "id": "container"
    }
  }, [_c('article', {
    staticClass: "content",
    attrs: {
      "id": "content"
    }
  }, [_c('Breadcrumb'), _c('WPageWrapper', {
    attrs: {
      "first-fetch-data-callback": _vm.fetchData
    }
  }, [_c('div', {
    staticClass: "sub_section_wrap book_common_particulars"
  }, [_c('section', {
    staticClass: "page_section"
  }, [_c('div', {
    staticClass: "page_section_inner"
  }, [_c('div', {
    staticClass: "book_particulars_wrap"
  }, [_c('div', {
    staticClass: "book_info_top"
  }, [_c('BookCover', {
    attrs: {
      "img": (_vm$book = _vm.book) === null || _vm$book === void 0 ? void 0 : _vm$book.coverImagePath,
      "alt": (_vm$book2 = _vm.book) === null || _vm$book2 === void 0 ? void 0 : _vm$book2.title,
      "book-size": "book_type4"
    }
  }), _c('div', {
    staticClass: "book_info_details"
  }, [_c('BookInfoTitle', {
    attrs: {
      "title": (_vm$book3 = _vm.book) === null || _vm$book3 === void 0 ? void 0 : _vm$book3.title,
      "book-seq": _vm.bookSeq,
      "share-type": "kids-book",
      "series": (_vm$book4 = _vm.book) === null || _vm$book4 === void 0 ? void 0 : _vm$book4.seriesTitle
    }
  }), _c('div', {
    staticClass: "book_info_publishing"
  }, [_c('ul', {
    staticClass: "book_publishing"
  }, [_c('BookPublishingItem', {
    attrs: {
      "title": "저자",
      "tag-name": "p"
    }
  }, [_c('BookAuthor', {
    attrs: {
      "authors": (_vm$book5 = _vm.book) === null || _vm$book5 === void 0 ? void 0 : _vm$book5.authors,
      "author-type": "KidsBookAuthorType"
    }
  })], 1), _c('BookPublishingItem', {
    attrs: {
      "title": "출간일"
    }
  }, [_vm._v(_vm._s(_vm._f("date")((_vm$book6 = _vm.book) === null || _vm$book6 === void 0 ? void 0 : _vm$book6.publicationDate)))]), (_vm$book7 = _vm.book) !== null && _vm$book7 !== void 0 && _vm$book7.schoolCurriculum ? _c('BookPublishingItem', {
    attrs: {
      "title": "교과연계",
      "line-break-contents": _vm.book.schoolCurriculum
    }
  }) : _vm._e(), (_vm$book8 = _vm.book) !== null && _vm$book8 !== void 0 && _vm$book8.awards ? _c('BookPublishingItem', {
    attrs: {
      "title": "수상내역",
      "line-break-contents": _vm.book.awards
    }
  }) : _vm._e(), (_vm$book9 = _vm.book) !== null && _vm$book9 !== void 0 && _vm$book9.dimension ? _c('BookPublishingItem', {
    attrs: {
      "title": "사양"
    }
  }, [_vm._v(_vm._s(_vm.book.dimension))]) : _vm._e(), (_vm$book10 = _vm.book) !== null && _vm$book10 !== void 0 && _vm$book10.price ? _c('BookPublishingItem', {
    attrs: {
      "title": "정가"
    }
  }, [_vm._v(_vm._s(_vm._f("price")(_vm.book.price)))]) : _vm._e(), (_vm$book11 = _vm.book) !== null && _vm$book11 !== void 0 && _vm$book11.stores.length ? _c('BookPublishingItem', {
    attrs: {
      "title": "구매처"
    }
  }, [_c('BookStoreTagList', {
    attrs: {
      "list": _vm.book.stores
    }
  })], 1) : _vm._e()], 1), _c('p', {
    staticClass: "book_detail_info book_tag_wrap"
  }, [_c('span', {
    staticClass: "tag_list_wrap type3"
  }, [(_vm$book12 = _vm.book) !== null && _vm$book12 !== void 0 && _vm$book12.photo && (_vm$book13 = _vm.book) !== null && _vm$book13 !== void 0 && (_vm$book13$photo = _vm$book13.photo) !== null && _vm$book13$photo !== void 0 && _vm$book13$photo.isVisible ? _c('span', {
    staticClass: "tag_list_item",
    attrs: {
      "title": (_vm$book14 = _vm.book) === null || _vm$book14 === void 0 ? void 0 : (_vm$book14$photo = _vm$book14.photo) === null || _vm$book14$photo === void 0 ? void 0 : _vm$book14$photo.title
    }
  }, [(_vm$book15 = _vm.book) !== null && _vm$book15 !== void 0 && _vm$book15.photo && (_vm$book16 = _vm.book) !== null && _vm$book16 !== void 0 && (_vm$book16$photo = _vm$book16.photo) !== null && _vm$book16$photo !== void 0 && _vm$book16$photo.isVisible ? _c('router-link', {
    attrs: {
      "to": {
        name: _vm.ROUTE_NAMES.KIDS_LIBRARY_EXHIBITION_DETAIL,
        params: {
          id: (_vm$book17 = _vm.book) === null || _vm$book17 === void 0 ? void 0 : (_vm$book17$photo = _vm$book17.photo) === null || _vm$book17$photo === void 0 ? void 0 : _vm$book17$photo.seq
        }
      }
    }
  }, [_c('span', {
    staticClass: "tag_box tag_data_1"
  }, [_c('span', {
    staticClass: "tag_text"
  }, [_vm._v("원화 전시")])])]) : _vm._e()], 1) : _vm._e(), _vm._l((_vm$book18 = _vm.book) === null || _vm$book18 === void 0 ? void 0 : _vm$book18.meets, function (meet, index) {
    return _c('span', {
      key: "meet-".concat(index),
      staticClass: "tag_list_item",
      attrs: {
        "title": meet.title
      }
    }, [meet.isVisible ? _c('router-link', {
      attrs: {
        "to": {
          name: _vm.ROUTE_NAMES.KIDS_LIBRARY_LECTURE_DETAIL,
          params: {
            id: meet.seq
          }
        }
      }
    }, [_c('span', {
      staticClass: "tag_box tag_data_2"
    }, [_c('span', {
      staticClass: "tag_text"
    }, [_vm._v("작가와의 만남 " + _vm._s(index + 1))])])]) : _vm._e()], 1);
  })], 2)])])], 1)], 1), (_vm$book19 = _vm.book) !== null && _vm$book19 !== void 0 && _vm$book19.attachments.length ? _c('BookRelatedData', {
    attrs: {
      "list": _vm.book.attachments
    }
  }) : _vm._e(), _c('BookInfoSummary', {
    attrs: {
      "contents": (_vm$book20 = _vm.book) === null || _vm$book20 === void 0 ? void 0 : _vm$book20.introduction
    }
  }), _c('BookInfoAuthorProfile', {
    attrs: {
      "authors": _vm.sortedAuthors,
      "is-kids-book": true
    }
  }), _vm.attachmentImages.length > 0 ? _c('div', {
    staticClass: "book_info_thumbnail page_mt80"
  }, [_c('div', {
    staticClass: "thumbnail"
  }, [_c('img', {
    attrs: {
      "src": _vm.attachmentImages[0].imagePath,
      "alt": "상세이미지"
    }
  })])]) : _vm._e()], 1)])])])])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }